import { useMutation, useQuery, UseQueryResult } from "react-query";
import { apiPost, apiGet } from "@shared/queryHooks/api";

type ExportKind = "candidates" | "jobs" | "job_applications" | "complete";

interface CreateOrgDataExportVariables {
  organizationId: number | string;
  kind?: ExportKind;
}

interface CreateOrgDataExportResponse {
  id: number;
  status: string;
  message: string;
  kind: ExportKind;
}

export const createOrganizationDataExport = async ({
  organizationId,
  kind = "candidates",
}: CreateOrgDataExportVariables): Promise<CreateOrgDataExportResponse> => {
  return await apiPost({
    path: `/organizations/${organizationId}/data_exports`,
    variables: { kind },
  });
};

export function useCreateOrganizationDataExport() {
  return useMutation(createOrganizationDataExport);
}

interface GetOrgDataExportVariables {
  organizationId: number | string;
  dataExportId: number | string;
}

interface GetOrgDataExportResponse {
  id: number;
  status: "pending" | "processing" | "completed" | "failed";
  kind: ExportKind;
  download_url?: string;
  error_message?: string;
}

const getOrganizationDataExport = async ({
  organizationId,
  dataExportId,
}: GetOrgDataExportVariables): Promise<GetOrgDataExportResponse> => {
  return await apiGet({ path: `/organizations/${organizationId}/data_exports/${dataExportId}` });
};

export function useGetOrganizationDataExport(
  organizationId: number | string,
  dataExportId: number | string,
): UseQueryResult<GetOrgDataExportResponse> {
  return useQuery(
    ["organizationDataExport", organizationId, dataExportId],
    () => getOrganizationDataExport({ organizationId, dataExportId }),
    { enabled: Boolean(organizationId && dataExportId) },
  );
}
